import { Component, OnInit, Inject, NgZone,ViewChild,ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { FormControl,FormGroup,FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';




@Component({
  selector: 'app-confirm-listado-iniciativas',
  templateUrl: './confirm-listado-iniciativas.component.html',
  styleUrls: ['./confirm-listado-iniciativas.component.css']
})
export class ConfirmListadoIniciativasComponent implements OnInit {
  confirmEnviarIniciativa:boolean=false;
  confirmFueraPeriodo:boolean=false;
  confirmDuplicarIniciativa:boolean=false;
  confirmEliminarIniciativa:boolean=false;
  confirmCancelacion:boolean=false;
  confirmHistorialIniciativa:boolean=false;
  confirmContactos:boolean=false;
  confirmComentarios:boolean=false;
  folioIniciativa:number;
  id_iniciativa:number;
  name:string;
  email:string;
  tablaHistorial:any[]=[];
  tablaHistorialCopia:any[]=[];

  tablaContactos:any[]=[];
  archivo:File;
  @ViewChild('labelComentarios',{static:false})
  labelComentarios: ElementRef;
  nombreArchivo:string;
  extencion:string;
  id_comentario:number;
  observacionesCancelacion:string;
  nombreRol:string;
  rol:number;
  estatus:number;
  rolesCatalogo: { id_rol: number; nombre_rol: string; }[];

  
  tablaComentarios:any[]=[];
  tablaComentariosNoVistos:any[]=[];
  tablaComentariosHistorial:any[]=[];
  listaEquipo:any[]=[];
  listaEquipoData:any[]=[];
  adv:boolean=false;
  response:any;



  sinComentarios:boolean=false;
  //Array para guardar los destinatarios de comentarios
  jsonDestinatarios: { id_rol: number; email_usuarioDestinatario: string; }[]=[];
  agregarComentario:boolean=false;

  
  //Form de comentarios
  formComentarios: FormGroup = new FormGroup({});
  //Varibles para asignar los comentarios 
  integrante = new FormControl();
  comentario = new FormControl();
  archivoBase:any;



  constructor(public dialog:MatDialog,  
    private dataService: DataService,
    private notifier: NotifierService,
    private zone: NgZone,    
    private router: Router,
    private fc: FormBuilder,
              @Inject(MAT_DIALOG_DATA) 
              public data: string) {

      //Form comentarios
    this.formComentarios=fc.group({
      integrante: ['', [Validators.required]],
      comentario: ['', [Validators.required]]
    })
  
  }


               
  ngOnInit(): void {
    //Envio de iniciatiava
    if(this.data['opcion']==3)
    {this.confirmHistorialIniciativa=true;
      this.folioIniciativa=this.data['folio'];
      this.getHistorialIniciativa(this.data['id_iniciativa']);
    }
    if(this.data['opcion']==4)
    {this.confirmEnviarIniciativa=true;}
    if(this.data['opcion']==5)
    {this.confirmFueraPeriodo=true;
      this.email=this.data['userLogin'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.rol=this.data['rolUserLogin'];
      this.data="";
    }
    if(this.data['opcion']==6)
    {this.confirmDuplicarIniciativa=true;
      this.folioIniciativa=this.data['folio'];
    }
    if(this.data['opcion']==7)
    {this.confirmCancelacion=true;
      this.folioIniciativa=this.data['folio'];
    }
    if(this.data['opcion']==8)
    {this.confirmEliminarIniciativa=true;
      this.folioIniciativa=this.data['folio'];
    }
    if(this.data['opcion']==9)
    {this.confirmContactos=true;
      this.folioIniciativa=this.data['folio'];
      this.getContactosIniciativa(this.data['id_iniciativa']);
    }
    if(this.data['opcion']==10)
    {
      this.rolesCatalogoMe();
      this.confirmComentarios=true;
      this.name=this.data['userName'];
      this.email=this.data['email'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.rol=this.data['idRol'];
      this.folioIniciativa=this.data['folio'];
      this.estatus=this.data['estatus'];
      this.getEquipoTrabajoComentario();    
      this.getComentariosIniciativa(this.data['id_iniciativa'],this.data['email'],this.rol);
      this.data="";
    }
  }

  //Cerrar el cuadro de dialogo
  closeDialog()
  {
    this.dialog.closeAll();
  }

  onFileChange(event: any) 
  {
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.archivo=file;
      this.labelComentarios.nativeElement.innerText = file.name;
      this.nombreArchivo=file.name;
    }
  }

  handleUpload(event:any) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    this.labelComentarios.nativeElement.innerText = file.name;
    this.nombreArchivo=file.name;
    reader.onload = () => {
        this.archivoBase=reader.result;
        let cont=this.archivoBase.split(',');
        this.archivoBase=cont[1];
    };
}

  
  //Método para cargar la lista de miembros de equipo
  getEquipoTrabajo()
  {
    this.dataService.getEquipoTrabajo(this.id_iniciativa).subscribe(data => {
      this.listaEquipoData = data['data'];
      this.listaEquipoData.forEach(element => {
        if(element['estatus_equipoTrabajo']==true && element['confirmacion_equipoTrabajo']==true)
        {
          this.listaEquipo.push(element);

        }
      }); 
    });
  }

  
  //Método para cargar la lista de miembros de equipo para comentarios
  getEquipoTrabajoComentario()
  {
    this.dataService.getEquipoTrabajo(this.id_iniciativa).subscribe(data => {
      this.listaEquipoData = data['data'];
      this.listaEquipoData.forEach(element => {
        if(element['estatus_equipoTrabajo']==true && element['confirmacion_equipoTrabajo']==true)
        {
          if(element['id_rol']==this.rol && element['email_usuario']==this.email)
          {
              //no se agrega a la lista
          }
          else{
            this.listaEquipo.push(element);
          }
        }
        
      }); 
      
    });

  }


  getHistorialIniciativa(id:number)
  {
    this.dataService.historialIniciativa(id).subscribe(
      data => {
        if (data['data']) 
        {
          this.tablaHistorialCopia=data['data'];
          this.tablaHistorialCopia.forEach(element=>{
            if(element['id_accion']==5 || element['id_accion']==6 || element['id_accion']==13 )
            {

            }else{
              this.tablaHistorial.push(element);

            }

          }

          );

          
          //this.tablaHistorial=data['data'];        
        }
        else{
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar el historial de la iniciativa. Contacta al administrador.'
        );
      }
    );

  }

  //Metodo para agregar periodo de envio
  addComentario(){
    this.agregarComentario=true;
  }


  getContactosIniciativa(id:number)
  {
    this.dataService.contactosIniciativa(id).subscribe(
      data => {
        if (data['data']) 
        {
          this.tablaContactos=data['data'];
        }
        else{
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar los contactos de la iniciativa. Contacta al administrador.'
        );
      }
    );

  }

  getComentariosIniciativa(id:number, email:string,rol:number)
  {
    this.dataService.comentariosIniciativa(id, email,rol).subscribe(
      data => {
        if (data['data']) 
        {
          this.tablaComentarios=data['data'];
          //Si no hay comentarios
          if(this.tablaComentarios.length==0)
          {
            this.sinComentarios=true;
          }
          //Si hay comentarios
          else{
              for(let i of this.tablaComentarios)
              {
                //vistos
                if(i['estatus_comentarioVisto']==false)
                {
                  this.tablaComentariosNoVistos.push(i);
                }//no vistos
                else{
                  this.tablaComentariosHistorial.push(i);
                }

              }

          }
        }
        else{
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar cargar los comentarios de la iniciativa. Contacta al administrador.'
        );
      }
    );

  }


  //Método para guardar los comentarios
  guardarComentario()
  {

    var myJsonString="";
    if(this.formComentarios.controls['integrante']['value'])
    {
      for (let num of this.formComentarios.controls['integrante']['value'])
      {
        let email=num['email_usuario'];
        let rol=num['id_rol'];
        let valores=
        {
          'email_usuarioDestinatario':email,
          'id_rol':rol
        }
        this.jsonDestinatarios.push(valores);
      }
       myJsonString = JSON.stringify(this.jsonDestinatarios);
    }
    
    
    let datos={
      'id_iniciativa':this.id_iniciativa,
      'descripcion_comentario': this.formComentarios.controls['comentario'].value,
      'email_usuarioComentario':this.email,
      'jsonDestinatarios':myJsonString,
      'id_rol':this.rol,
      'nombre_archivoComentario': this.nombreArchivo
    }
    
    this.dataService.agregarComentarios(datos).subscribe(
      data => {
        if (data['objData']) 
        {
          this.id_comentario=data['objData']['id_comentario'];
          if(this.nombreArchivo)
          {
            //Subimos el archivo
            this.dataService.subirArchivoComentarios(this.archivo,this.id_iniciativa,this.id_comentario).subscribe(
              data => {
                if (data['objData']) 
                {
                  this.notifier.notify(
                    'success',
                    'Comentario enviado correctamente.'
                  );}
              },
              error => {
                console.error(error);
                this.notifier.notify(
                  'error',
                  'Ha ocurrido un error al intentar enviar su comentario. Verifique su conexión de red o contacte al administrador.'
                );
              }
            )}
          else{
            this.notifier.notify(
              'success',
              'Comentario enviado correctamente.'
            );
          }
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar enviar su comentario. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );
  }

  enviarSolicitud()
  {

  let datos={
      'id_iniciativa':this.id_iniciativa,
      'userlogin':this.email,
      'justificacion':this.data,
      'rolUserlogin':this.rol
    }

    this.dataService.solicitudEnvioFueraPeriodo(datos).subscribe(
      data => {
        if (data['objData']) 
        {
          if(this.nombreArchivo)
          {
            //Subimos el archivo
            this.dataService.subirArchivoSolicitudEnvio(this.archivoBase,this.nombreArchivo,this.id_iniciativa).subscribe(
              data => {
                if (data['objData']) 
                {
                  this.notifier.notify(
                    'success',
                    'Solicitud enviada correctamente.'
                  );
                  this.response=data;
                  this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
                }
              },
              error => {
                console.error(error);
                this.notifier.notify(
                  'error',
                  'Ha ocurrido un error al intentar cargar su archivo. Verifique su conexión de red o contacte al administrador.'
                );
              }
            )
          }//cierre if nombre archivo


        }//cierre if data
      },//cierre data
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar enviar solicitud. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );//cierre endpoint
  }//cierre cambio 




  descargarArchivo(archivo:string,id_comentario:number)
  {
    this.dataService.descargarArchivoComentarios(this.id_iniciativa,archivo,id_comentario).subscribe(res => {
      // Este es necesario para crear un objeto blob con el tipo de archivo
      // puesto explicitamente, de lo contrario solo Chrome funcionara correctamente
      let newBlob = new Blob([res], { type: this.obtenerTipoArchivo(archivo) });
      // IE no permite objetos blob directamente en el atributo href de un link
      // en su lugar hay que usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
       let link = document.createElement('a');
      link.href = data;
      link.download = archivo;
      // Esta linea es necesaria desde que link.click() ya no funciona en las ultimas versiones de firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

      setTimeout(function () {
        // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });

  }

  private obtenerTipoArchivo(archivo: string): string {
    let tipoArchivo: string;
    let extencion: string = archivo.split('.').pop();

    switch (extencion) {
      case 'pdf':
        tipoArchivo = 'application/pdf';
        break;
      case 'xls':
        tipoArchivo = 'application/vnd.ms-excel';
        break;
      case 'xlsx':
        tipoArchivo = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'csv':
        tipoArchivo = 'application/csv';
        break;
      case 'zip':
        tipoArchivo = 'application/zip';
        break;
      case 'rar':
        tipoArchivo = 'application/x-rar-compressed';
        break;

      default:
        tipoArchivo = 'text/plain';
        break;
    }
    return tipoArchivo;
  }


  //Método para cargar los roles activos de BD
  rolesCatalogoMe()
  {
    this.dataService.obtenerTiposUsuariosv2().subscribe(
      data => {
        this.rolesCatalogo = data['data'];
        this.nombreRoles(this.rol);
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Metodo para obtener el nombre del rol
  nombreRoles(rol) 
 {
   if (this.rolesCatalogo.indexOf(rol) === -1) 
   {
     for (var i in this.rolesCatalogo) 
     {
       if(this.rolesCatalogo[i].id_rol==rol)
       {
         this.nombreRol=this.rolesCatalogo[i]['nombre_rol'];
       }
       
     }
   } else if (this.rolesCatalogo.indexOf(rol) > -1) {  
   }
}

}
